export default __webpack_public_path__ + "static/Clock-f261a3571d0573269a1ecd957e120f42.svg";